<script>
    export default {
        name: "FocusMixin",
        data () {
            return {}
        },
        methods: {
            getFocusBgColor () {
                return this.myData.backgroundFocusColor;
            },

            getFocusBorderColor () {
                return this.myData.borderFocusColor;
            },

            setFocusBgColor (val) {
                this.changeMyData({ backgroundFocusColor: val });
                this.applyStyle({
                    styleProp:'backgroundColor',
                    value : val,
                    targetState: ":focus"
                })

            },

            setFocusBorderColor (val) {
                this.changeMyData({ borderFocusColor: val });
                this.applyStyle({
                    styleProp:'borderColor',
                    value : val,
                    targetState: ":focus"
                })

            }
        }
    }
</script>

